import styled from 'react-emotion';
import theme from '@ublend-npm/aulaui-next-web/themes/default';

import CommonBackButton from '../../../common/BackButton/BackButton';

export const dialogStyle = {
  padding: '0 24px 16px 24px',
};

export const infiniteListStyle = {
  listStyle: 'none',
};

export const BackButton = styled(CommonBackButton)`
  margin-left: -8px;
`;

export const Text = styled('span')`
  display: block;
  font-family: ${theme.font.family.workSans};
  font-size: ${theme.font.size.large};
  font-weight: ${theme.font.weight.semiBold};
  line-height: ${theme.font.lineHeight.copy};
  margin-top: ${theme.spacing.xLarge};
`;
